import Vue from 'vue'
import VueRouter from 'vue-router'
import { setInfo, getInfo } from '@/utils/auth'

Vue.use(VueRouter)



const routes = [{
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'home',
        component: () =>
            import ('@/views/clientshome/index.vue'),
        meta: {
            type: 'client',
            requireAuth: true,
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        },
    },
    {
        path: '/home/newsList',
        name: 'newsList',
        component: () =>
            import ('@/views/clientshome/components/newsboard/textnews/newsList.vue'),
        meta: {

            NoTabPage: true,
            requireAuth: true,
        },
    },
    {
        path: '/home/upFileWork',
        name: 'upFileWork',
        component: () =>
            import ('@/views/clientshome/components/upFileWork/index.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        },
    },
    {
        path: '/home/specialColumn',
        name: 'specialColumn',
        component: () =>
            import ('@/views/clientshome/components/specialColumn/index.vue'),
        meta: {

            NoTabPage: true,
            requireAuth: true,
        },
    },
    {
        path: '/search',
        name: 'search',
        component: () =>
            import ('@/views/search/homeSearch.vue'),
        meta: {
            // type: 'client',
            requireAuth: true,
            NoTabPage: true,
            NoNeedHome: false // 添加该字段，表示不需要home模板
        },
    },
    {
        path: '/personCenter',
        name: 'personCenter',
        component: () =>
            import ('@/views/personCenter/index.vue'),
        children: [{
                path: '/personCenter/personhome', //首页
                name: 'personhome',
                component: () =>
                    import ('@/views/personCenter/component/personhome.vue'),
            },
            {
                path: '/personCenter/information', //消息
                name: 'information',
                component: () =>
                    import ('@/views/personCenter/component/information.vue'),
            },
            {
                path: '/personCenter/activity', //活动
                name: 'activity',
                component: () =>
                    import ('@/views/personCenter/component/activity.vue'),
            },
            {
                path: '/personCenter/task', //任务
                name: 'task',
                component: () =>
                    import ('@/views/personCenter/component/task.vue'),
            },
            {
                path: '/personCenter/learningProgress', //学习进度
                name: 'learningProgress',
                component: () =>
                    import ('@/views/personCenter/component/learningProgress.vue'),
            },
            {
                path: '/personCenter/testProgress', //考试进度
                name: 'testProgress',
                component: () =>
                    import ('@/views/personCenter/component/testProgress.vue'),
            },
            {
                path: '/personCenter/trainProgress', //培训进度
                name: 'trainProgress',
                component: () =>
                    import ('@/views/personCenter/component/trainProgress.vue'),
            },
            {
                path: '/personCenter/educational', //教案心得
                name: 'educational',
                component: () =>
                    import ('@/views/personCenter/component/educational.vue'),
            },
            {
                path: '/personCenter/policerank', //警衔提升
                name: 'policerank',
                component: () =>
                    import ('@/views/personCenter/component/policerank.vue'),
            },
            {
                path: '/personCenter/teachermsg', //教官信息
                name: 'teachermsg',
                component: () =>
                    import ('@/views/personCenter/component/teachermsg.vue'),
            },
            {
                path: '/personCenter/iamStudy', //我的学习
                name: 'iamStudy',
                component: () =>
                    import ('@/views/personCenter/component/iamStudy.vue'),
            },
            {
                path: '/personCenter/iamExam', //我的考试 
                name: 'iamExam',
                component: () =>
                    import ('@/views/personCenter/component/iamExam.vue'),
            },
            {
                path: '/personCenter/kqCountBox', //我的考勤 
                name: 'kqCountBox',
                component: () =>
                    import ('@/views/personCenter/component/component/kqCountBox.vue'),
            },
            {
                path: '/personCenter/iamTrain', //我的调训
                name: 'iamTrain',
                component: () =>
                    import ('@/views/personCenter/component/iamTrain.vue'),
            },
            {
                path: '/personCenter/iamVote', //我的测评
                name: 'iamVote',
                component: () =>
                    import ('@/views/personCenter/component/iamVote.vue'),
            },
            {
                path: '/personCenter/psychologicalTest', //心理测评
                name: 'psychologicalTest',
                component: () =>
                    import ('@/views/personCenter/component/psychologicalTest.vue'),
            },
            {
                path: '/personCenter/iamcertificate', //我的证书
                name: 'iamcertificate',
                component: () =>
                    import ('@/views/personCenter/component/iamcertificate.vue'),
            },
            {
                path: '/personCenter/iamcollect', //我的收藏
                name: 'iamcollect',
                component: () =>
                    import ('@/views/personCenter/component/iamcollect.vue'),
            },
            {
                path: '/personCenter/iamTrainDate', //我的训历
                name: 'iamTrainDate',
                component: () =>
                    import ('@/views/personCenter/component/iamTrainDate.vue'),
            },
            {
                path: '/personCenter/upLoadResource', //我的上传
                name: 'uploadResource',
                component: () =>
                    import ('@/views/personCenter/component/uploadResource.vue'),
            },
            {
                path: '/personCenter/iamApplication', //免训申请
                name: 'iamApplication',
                component: () =>
                    import ('@/views/personCenter/component/iamApplication.vue'),
            },
            {
                path: '/personCenter/evaluation', // 健康测评
                name: 'evaluation',
                component: () =>
                    import ('@/views/personCenter/component/evaluation.vue'),
            },
            {
                path: '/personCenter/iamBstanRtsis', //教官日志列表
                name: 'iamBstanRtsis',
                component: () =>
                    import ('@/views/personCenter/component/iamBstanRtsis.vue'),
            },
            {
                path: '/personCenter/iamClasserLogs', //班级管理
                name: 'iamClasserLogs',
                component: () =>
                    import ('@/views/personCenter/component/iamClasserLogs.vue'),
            },
        ],
    },

    {
        path: '/personCenter/videoleam', //成绩审核
        name: 'videoleam',
        component: () =>
            import ('@/views/personCenter/component/videoleamIndex.vue'),
    },


    {
        path: '/personCenter/scoreList', //成绩审核
        name: 'scoreList',
        component: () =>
            import ('@/views/personCenter/component/score/scoreList.vue'),
    },
    {
        path: '/personCenter/grade', //作品审核
        name: 'grade',
        component: () =>
            import ('@/views/personCenter/grade.vue'),
    },
    {
        path: '/personCenter/gradedafen', //打分页面
        name: 'gradedafen',
        component: () =>
            import ('@/views/personCenter/gradedafen.vue'),
    },
    {
        path: '/personCenter/continuetask', //继续任务
        name: 'continuetask',
        component: () =>
            import ('@/views/personCenter/component/component/continuetask.vue'),
    },
    {
        path: '/home/newsgetone',
        name: 'newsgetone',
        component: () =>
            import ('@/views/clientshome/components/newsboard/textnews/newsgetone.vue'),
        meta: {
            // type: 'manage',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () =>
            import ('@/views/manages/dashboard/index.vue'),
        meta: {
            type: 'client',
            NoTabPage: true,
            // requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },

    {
        path: '/sourceslist',
        name: 'sourceslist',
        component: () => import ('@/views/resources/index.vue'),
        meta: {
            type: 'client',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },

    { //资源视频路由
        path: '/sourceslist/videoLearn',
        name: 'videoLearn',
        component: () =>
            import ('@/views/resources/videoLearn/index.vue'),
        meta: {
            NoTabPage: true,
            // requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },

    {
        path: '/diaoy',
        name: 'vote',
        component: () =>
            import ('@/views/vote/index.vue'),
        meta: {
            type: 'client',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/diaoy/questionget',
        name: 'questionget',
        component: () =>
            import ('@/views/vote/components/questionget.vue'),
        meta: {
            // type: 'client',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },

    {
        path: '/diaoy/statistics',
        name: 'statistics',
        component: () =>
            import ('@/views/vote/components/statistics.vue'),
        meta: {
            // type: 'client',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },

    // {
    //     path: '/diaoy/prePhone',
    //     name: 'prePhone',
    //     component: () =>
    //         import ('@/views/vote/components/prephone.vue'),
    //     meta: {
    //         // type: 'client',
    //         NoTabPage: true,
    //         NoNeedHome: true // 添加该字段，表示不需要home模板
    //     }
    // },


    {
        path: '/diaoa',
        name: 'diaoa', //教官库
        component: () =>
            import ('@/views/teacher/index.vue'),
        // children:[

        // ],
        meta: {
            type: 'client',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/diaoa/blog',
        name: 'diaoablog', //教官库博客
        component: () =>
            import ('@/views/teacher/blogOne.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
        }
    },
    {
        path: '/diaoa/blogList',
        name: 'diaoablogList', //教官库博客
        component: () =>
            import ('@/views/teacher/blogList.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
        }
    },
    { //教官个人数据路由
        path: '/diaoa/personData',
        name: 'personData',
        component: () =>
            import ('@/views/teacher/components/teacherdata/components/personData.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
        }
    },



    {
        path: '/mooc',
        name: 'mooc',
        component: () =>
            import ('@/views/mooc/index.vue'),
        meta: {
            type: 'client',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        },
    },
    {
        path: '/mooc/disstations',
        name: 'disstations',
        component: () =>
            import ('@/views/mooc/components/recentlyreleas/components/disstations.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板

        }
    },
    {
        path: '/mooc/disstationList',
        name: 'disstationList',
        component: () =>
            import ('@/views/mooc/components/recentlyreleas/components/disstationList.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板

        }
    },

    {
        path: '/mooc/moocAppraise',
        name: 'moocAppraise',
        component: () =>
            import ('@/views/mooc/moocAppraise.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板

        },
    },

    {
        path: '/mooc/policeAcademyMore',
        name: 'policeAcademyMore',
        component: () =>
            import ('@/views/mooc/policeAcademyMore.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板

        }
    },

    {
        path: '/train',
        name: 'train',
        component: () =>
            import ('@/views/train/index.vue'),
        meta: {
            type: 'client',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/train/trainBase',
        name: 'trainBase',
        component: () =>
            import ('@/views/train/trainBase/trainBase'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/train/Basemore',
        name: 'baseMore',
        component: () =>
            import ('@/views/train/trainBase/baseMore'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/train/trainclass',
        name: 'trainclass',
        component: () =>
            import ('@/views/train/trainclass/index'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/studyclass',
        name: 'studyclass',
        component: () =>
            import ('@/views/mooc/components/studyclass/index.vue'),
        meta: {
            NoTabPage: true,
            // requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        },
    },
    {
        path: '/studyclassDetail',
        name: 'studyclassDetail',
        component: () =>
            import ('../views/mooc/components/studyclass/components/studyclassDetail.vue'),
        meta: {
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }

    },



    {
        path: '/exam',
        name: 'exam',
        component: () =>
            import ('@/views/exam/index.vue'),
        meta: {
            type: 'client',
            NoTabPage: true,
            requireAuth: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/certificate',
        name: 'certificate',
        component: () =>
            import ('@/views/certificate/index.vue'),
        meta: {
            type: 'client',
            requireAuth: true,
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/dowload',
        name: 'dowload',
        component: () =>
            import ('@/views/dowload/index.vue'),
        meta: {
            type: 'client',
            requireAuth: true,
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/certificate/peoplecerticate',
        name: 'peoplecerticate',
        component: () =>
            import ('@/views/certificate/peoplecerticate/index'),
        meta: {
            requireAuth: true,

            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/Details', //正式考试
        name: 'Details',
        component: () =>
            import ('@/views/exam/paper/Details.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/Breakthrough', //闯关模式
        name: 'Breakthrough',
        component: () =>
            import ('@/views/exam/paper/Breakthrough.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/BrushTopic', //刷题模式
        name: 'BrushTopic',
        component: () =>
            import ('@/views/exam/paper/BrushTopic.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        },
    },
    {
        path: '/BrushTopic2', //刷题模式
        name: 'BrushTopic2',
        component: () =>
            import ('@/views/exam/paper/BrushTopic2.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        },
    },
    {
        path: '/MockExam', //模拟考试
        name: 'MockExam',
        component: () =>
            import ('@/views/exam/paper/MockExam.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/simulationExam', //模拟考试
        name: 'simulationExam',
        component: () =>
            import ('@/views/exam/paper/simulationExam.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/simulationExamPerson', //调训考试
        name: 'simulationExamPerson',
        component: () =>
            import ('@/views/exam/paper/simulationExamPerson.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/subMulationExamPerson', //查看调训考试
        name: 'subMulationExamPerson',
        component: () =>
            import ('@/views/exam/paper/subMulationExamPerson.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/subMulationExam', //模拟考试分数
        name: 'subMulationExam',
        component: () =>
            import ('@/views/exam/paper/subMulationExam.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/examprviewPaper', //模拟考试分数
        name: 'examprviewPaper',
        component: () =>
            import ('@/views/exam/components/prviewPaper.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/prviewPaper', //正式考试分数
        name: 'prviewPaper',
        component: () =>
            import ('@/views/personCenter/component/component/prviewPaper.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/paperDetail', //获取分数
        name: 'paperDetail',
        component: () =>
            import ('@/views/exam/paper/paperDetail.vue'),
        meta: {
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/AppStore', //
        name: 'AppStore',
        component: () =>
            import ('@/views/AppStore/index'),
        meta: {
            requireAuth: true,
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },

    {
        path: '/userArchives', //训历档案
        name: 'userArchives',
        component: () =>
            import ('@/views/train/archives/userArchives.vue'),
        meta: {
            type: 'manage',
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/applicationFrom', //免训申请表
        name: 'applicationFrom',
        component: () =>
            import ('@/views/train/archives/applicationFrom.vue'),
        meta: {
            type: 'manage',
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/healthReport', //健康评估报告
        name: 'healthReport',
        component: () =>
            import ('@/views/train/archives/healthReport.vue'),
        meta: {
            type: 'manage',
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/trainingReport', //教官日志展示页
        name: 'trainingReport',
        component: () =>
            import ('@/views/train/archives/trainingReport.vue'),
        meta: {
            type: 'manage',
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
    {
        path: '/classReport', //班主任日志展示页
        name: 'classReport',
        component: () =>
            import ('@/views/train/archives/classReport.vue'),
        meta: {
            type: 'manage',
            NoTabPage: true,
            NoNeedHome: true // 添加该字段，表示不需要home模板
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {

        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    // 检查目标路由是否需要认证
    if (to.fullPath != '/home') {
        // 检查用户是否已登录
        if (!getInfo("tokens")) {
            // 未登录则重定向到登录页面
            window.clikLogin();
        } else {
            localStorage.removeItem("oldtimes");
            next() // 已登录则继续
        }
    } else {
        next() // 不需要认证的路由直接放行
    }
})

export default router